import { render, staticRenderFns } from "./HorizonScrollIcon.vue?vue&type=template&id=cbe6a3f0&"
import script from "./HorizonScrollIcon.vue?vue&type=script&lang=js&"
export * from "./HorizonScrollIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports